import React, { memo, useState, useContext, useEffect, useRef, createRef } from "react";
import { Box, Button, Divider } from "@mui/material";
import Tabla from "./Componentes/Tabla";
import Modal from "./Componentes/Modal";
// import ModalB from "../../../components/Extra/ModalB";
// import BarraTablas from "../../../components/BarraTablas/BarraTablas";
import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
// import ModalATS from "./Componentes/ModalATS";
import AuthContext from "../../../Context/Auth/AuthContext";
import ModalInventario from "../../Configuración/Inventario/Componentes/Modal";
import ModalProveedor from "../../Compras/Proveedores/Personas_Contable/Componentes/Modal";
import ModalProveedorISP from "../../Compras/Proveedores/Personas_ISP/Componentes/Modal";
import ModalProveedorVet from "../../Veterinaria/Personas_Veterinaria/Componentes/Modal";
import ModalProveedorGas from "../../Gasolinera/Personas_Gasolinera/Componentes/Modal";
import ModalTraido from "./ModalTraido";
import Categorias from "../../Configuración/Categorias/Categorias";
import Subcategorias from "../../Configuración/Subcategorias/Subcategorias";
import Axios from "axios";
import io from "socket.io-client";
import { FechaExacta, socketUrl } from "../../../config/const";
import BarraTablas from "../../components/Tablas/BarraTablas";
import ModalB from "../../components/Modal/ModalB";
import DialogOpciones from "../../components/Dialogs/DialogOpciones";
import { Add, Search } from "@mui/icons-material";
import { usePermiso } from "../../../hooks/usePermiso";
const GuiaRemision = (props) => {
  const { tienePermiso, alertaPermiso } = usePermiso("GuiaRemision");
  const defaultFullBuscador = () => {
    const json = {};
    [
      ...columns,
      {
        id: "actaFechaInstalacion",
        label: "Fec. Ins.",
        minWidth: 25,
        tipo: "fecha",
        orden: 1,
        propiedad: "actaFechaInstalacion",
        align: "center",
        ocultar: false,
      },
    ].forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (item.ocultar) {
          return;
        }
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });
    return json;
  };
  const [openDialogOpciones, setopenDialogOpciones] = useState(false);
  const {
    documento,
    settab,
    setarrayExportHijos,
    desdeOtroLugarPersona,
    itemRelacionadoPadre,
  } = props;

  useEffect(() => {
    if (desdeOtroLugarPersona) {
      settab("");
      setarrayExportHijos(arrayExport.map((item) => item[campoExport]));
    }
    // eslint-disable-next-line
  }, [arrayExport]);
  // DATA DEL STATE

  const [rows, setrows] = useState(null);

  const columns = [
    {
      id: "venNumFactura",
      label: "Num. Documento",
      minWidth: 100,
      tipo: "string",
      propiedad: "venNumFactura",
    },
    {
      id: "venRucCliente",
      label: "Ruc. Cliente",
      minWidth: 100,
      tipo: "string",
      propiedad: "venRucCliente",
    },
    {
      id: "venNomCliente",
      label: "Cliente",
      minWidth: 100,
      tipo: "string",
      propiedad: "venNomCliente",
    },
    {
      id: "venFormaPago",
      label: "F. Pago",
      minWidth: 100,
      tipo: "string",
      variante: "autocompleteDataDefault",
      propiedadesMostrar: 1,
      campoData1: "fpagoNombre",
      getData: async () => {
        const res = await clienteAxios.get("/formaPagos/filtro/0");
        return res;
      },
      propiedad: "venFormaPago",
    },
    {
      id: "venFechaFactura",
      label: "F. GuiaRemision",
      minWidth: 100,
      tipo: "fecha",
      propiedad: "venFechaFactura",
    },
    {
      id: "venFacturaCredito",
      label: "F. Crédito",
      minWidth: 100,
      tipo: "string",
      variante: "autocompleteComun",
      data: ["SI", "NO"],
      propiedad: "venFacturaCredito",
    },
    {
      id: "venTotal",
      label: "Total",
      minWidth: 100,
      tipo: "numero",
      propiedad: "venTotal",
    },
    {
      id: "venEstado",
      label: "Estado",
      minWidth: 100,
      tipo: "string",
      propiedad: "venEstado",
    },
    {
      id: "venAutorizacion",
      label: "Autorización",
      minWidth: 100,
      tipo: "string",
      propiedad: "venAutorizacion",
    },
    {
      id: "venEnvio",
      label: "Envio",
      minWidth: 100,
      tipo: "string",
      propiedad: "venEnvio",
    },
    {
      id: "venObservacion",
      label: "Observación",
      minWidth: 100,
      tipo: "string",
      propiedad: "venObservacion",
    },
    {
      id: "venUser",
      label: "User",
      minWidth: 100,
      tipo: "string",
      propiedad: "venUser",
    },
  ];

  const [ObjectoActivo, setObjetoActivo] = useState({
    fechaFacturaFin: FechaExacta,
    id_transportista: "",
    tipoDocuTransportista: "",
    ruc_transportista: "",
    nom_transportista: "",
    dirPartida: "",
    venEmpRegimen: "",
    venProductosAntiguos: [],
    venTotalRetencion: "0.00",
    venIdCliente: "1",
    venRucCliente: "9999999999999",
    venTipoDocuCliente: "RUC",
    venNomCliente: "CONSUMIDOR FINAL",
    venEmailCliente: ["sin@sincorreo.com"],
    venTelfCliente: "0000000001",
    venCeluCliente: "0000000001",
    venDirCliente: "s/n",
    venEmpRuc: "",
    venEmpNombre: "",
    venEmpComercial: "",
    venEmpDireccion: "",
    venEmpTelefono: "",
    venEmpEmail: "",
    venEmpObligado: "",
    venFormaPago: "TRANSFERENCIA",
    venNumero: "0",
    venFacturaCredito: "NO",
    venDias: "0",
    venAbono: "0",
    venDescPorcentaje: "0",
    venOtrosDetalles: "",
    venObservacion: "",
    venSubTotal12: "",
    venSubtotal0: "",
    venDescuento: "",
    venSubTotal: "",
    venTotalIva: "",
    venTotal: "0.00",
    venCostoProduccion: "",
    venUser: "",
    venFechaFactura: `${new Date().getFullYear()}-${(
      "0" +
      (new Date().getMonth() + 1)
    ).slice(-2)}-${("0" + new Date().getDate()).slice(-2)}`,
    venNumFactura: "",
    venNumFacturaAnterior: "",
    venAutorizacion: "0",
    venFechaAutorizacion: "",
    venErrorAutorizacion: "NO",
    venEstado: "GENERAR GUIA REMISION",
    venEnvio: "NO",
    fechaSustentoFactura: "",
    venEmpresa: "",
    venProductos: [
      // {
      //   id: "a77eaa76-4e8e-4a3a-97af-58b599edbd08",
      //   cantidad: "1",
      //   codigo: "7",
      //   descripcion: "DESPARASITACIÓN INTERNA 1-15 KG",
      //   valUnitarioInterno: "7.00",
      //   valorUnitario: "7.00",
      //   recargoPorcentaje: "0.00",
      //   recargo: "0.00",
      //   descPorcentaje: "0",
      //   descuento: "0.00",
      //   precioSubTotalProducto: "7.00",
      //   valorIva: "0.00",
      //   costoProduccion: "7.00",
      //   llevaIva: "NO",
      //   incluyeIva: "NO",
      // },
    ],
  });
  const [pagination, setpagination] = useState(null);
  // FUNCIONES STATE
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estado
  ) => {
    const res = await clienteAxios.get(
      `/guia_remisiones/?cantidad=${cantidad}&page=${page}&search=${
        search ? search : ""
      }&input=${input ? input : ""}&orden=${orden ? orden : ""}&datos=${
        datos ? datos : ""
      }&rucempresa=${rucempresa ? rucempresa : ""}&estado=${
        estado ? estado : ""
      }&documento=${documento ? documento : ""}&allData=${tienePermiso(
        "allData"
      )}`
    );

    return res;
  };

  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estado
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      estado
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    estado
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      estado
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
    // dispatch({
    //   type: OBTENER,
    //   payload: {
    //     results: res.data.data.results,
    //     pagination: res.data.data.pagination,
    //   },
    // });
  };
  const agregarState = async (item) => {
    try {
      setrows([item, ...rows]);

      setpagination({
        ...pagination,
        numRows: pagination.numRows + 1,
      });
    } catch (error) {}
  };

  const editarState = async (item) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR.guiaId === item.guiaId) {
          return item;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };

  const eliminarState = async (_id) => {
    try {
      const resRows = rows.filter((row) => {
        return row.guiaId !== _id;
      });
      setrows(resRows);
      setpagination({
        ...pagination,
        numRows: pagination.numRows - 1,
      });
    } catch (error) {}
  };
  const eliminarSeleccionState = async (_ids) => {
    const resRows = rows.filter((row) => {
      return !_ids.some((item) => {
        return item === row.guiaId;
      });
    });
    setpagination({
      ...pagination,
      numRows: pagination.numRows - _ids.length,
    });
    setrows(resRows);
  };

  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  const rowsImportState = (rows) => {
    // dispatch({
    //   type: IMPORTAR_ROWS,
    //   payload: rows,
    // });
    setrows(rows);
  };
  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  const [tabla] = useState("guia_remision");
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });

  const socket = useRef();
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });
    socket.current.on("server:idRegistro", (data) => {
      window.open(`${data.ruta}`, "_blank");
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }

    if (desdeOtroLugarPersona && item.venRucCliente !== documento) {
      return;
    }
    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      if (
        usuario.empCategoria === "GASOLINERA" &&
        item.venUser === usuario.usuario
      ) {
        // Axios.post(
        //   `http://localhost/ticket_gasolinera/ticket.php`,
        //   JSON.stringify(item)
        // );
      }

      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item.guiaId);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);
  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa, codigo },
    usuario,
  } = useContext(AuthContext);
  const [openSubCategoria, setopenSubCategoria] = useState(false);
  const [openCategoria, setopenCategoria] = useState(false);

  const [OpenProveedorModalI, setOpenProveedorModalI] = useState(false);
  const [OpenProveedor, setOpenProveedor] = useState(false);
  const [editarProveedor, seteditarProveedor] = useState(false);
  const [openInventario, setopenInventario] = useState(false);
  const [editarInventario, seteditarInventario] = useState(false);
  const [estadoRequest, setestadoRequest] = useState("PROCESADAS");
  const [open, setopen] = useState(false);
  const [buscando, setbuscando] = useState(false);
  const [editar, seteditar] = useState(false);
  const [search, setsearch] = useState("");
  const [cargando, setcargando] = useState(false);
  const [input, setinput] = useState({
    id: "guiaId",
    label: "ID",
    minWidth: 150,
    tipo: "string",

    propiedad: "guiaId",
  });
  const [arrayExport, setarrayExport] = useState([]);
  const [campoExport] = useState("guiaId");

  const [orden, setorden] = useState(false);
  const [openMB, setopenMB] = useState(false);
  const [fullBuscador, setfullBuscador] = useState({});
  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  // input
  //
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );

    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };

  const handleSearch = async () => {
    setcargando(true);
    setPage(0);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setcargando(false);
  };
  useEffect(() => {
    const fullBRes = defaultFullBuscador();

    setfullBuscador(fullBRes);
    // eslint-disable-next-line
  }, []);
  const funcionDefault = async () => {
    setcargando(true);
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify(fullBRes),
      rucempresa,
      estadoRequest
    );

    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };
  const inputXmlSri = createRef();
  const funcArchivoXmlSri = async (e) => {
    if (e.target.files.length === 0) return;
    try {
      const existeUnNoXML = Object.values(e.target.files).some(
        (file) => file.type !== "text/xml"
      );
      if (existeUnNoXML) {
        return mostrarAlerta("El archivo no es XML");
      } else {
        const formDataLogos = new FormData();
        Object.values(e.target.files).forEach((file, index) => {
          formDataLogos.append(`archivo${index + 1}`, file);
        });
        formDataLogos.append("tipo", "compras");
        formDataLogos.append("rucempresa", rucempresa);
        formDataLogos.append("codigo", codigo);

        const res = await clienteAxios.post(
          "/uploads_xml/retencion",
          formDataLogos
        );
        mostrarAlerta(res.data.msg, "success");
      }
    } catch (error) {
      mostrarAlerta("Hubo un error al subir el archivo XML", "error");
    }
  };
  // INVENTARIO
  const [ObjectoActivoInventario, setObjetoActivoInventario] = useState({
    invSerie: "0",
    invTipo: "",
    invNombre: "",
    invDescripcion: "",
    invCosto1: "",
    invCosto2: "",
    invCosto3: "",
    invStock: "",
    invIva: "SI",
    invIncluyeIva: "SI",
    invEstado: "ACTIVA",
    invBodegas: [],
    invprecios: [],
    invProveedor: "",
    invCategoria: "",
    invSubCategoria: "",
    invUnidad: "",
    invMarca: "",
    invSubsidio: "0",
    invPlanCuenta: "",
    invEmpresa: "",
    invUser: "admin",
    invFecReg: "",
    Todos: "",
  });
  const changeObjetoActivoStateInventario = (item) => {
    setObjetoActivoInventario(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  // Proveedor
  const [ObjectoActivoProveedor, setObjetoActivoProveedor] = useState({
    perISPContratos: [],
    perNombreComercial: "",
    perEmpresa: [],
    perPais: "",
    perProvincia: "",
    perCanton: "",
    perTipoProveedor: "BIENES",
    perTiempoCredito: "0",
    perDocTipo: "",
    perDocNumero: "",
    perPerfil: [],
    perNombre: "",
    perDireccion: "",
    perObligado: "NO",
    perCredito: "NO",
    perTelefono: "0",
    perCelular: ["+593"],
    perEstado: "ACTIVO",
    perObsevacion: "",
    perEmail: ["sin@sincorreo.com"],
    perOtros: ["ZZZ9999"],
    perNickname: "",
    perUser: "",
    perFecReg: "",
    perFoto: "",
    perUbicacion: {
      longitud: "",
      latitud: "",
    },
    perDocumento: "",
    perGenero: "M",
    perRecomendacion: "OTROS",
    perFecNacimiento: "",
    perEspecialidad: "",
    perTitulo: "",
    perSenescyt: "",
    perPersonal: "INTERNO",
    validateEmail: 1,
  });
  const changeObjetoActivoStateProveedor = (item) => {
    setObjetoActivoProveedor(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };

  return (
    <Box>
      <ModalTraido
        open={openCategoria}
        setopen={setopenCategoria}
        titulo="Categoría"
        Componente={Categorias}
        socket={socket}
      />
      <ModalTraido
        open={openSubCategoria}
        setopen={setopenSubCategoria}
        titulo="Sub Categoría"
        Componente={Subcategorias}
        socket={socket}
      />
      <ModalProveedor
        estadoRequest={"PROVEEDOR"}
        open={OpenProveedorModalI}
        setopen={setOpenProveedorModalI}
        editar={editarProveedor}
        seteditar={seteditarProveedor}
        socket={socket}
        ObjectoActivo={ObjectoActivoProveedor}
        changeObjetoActivoState={changeObjetoActivoStateProveedor}
      />
      {usuario.empCategoria === "CONTABLE" && (
        <ModalProveedor
          estadoRequest={"CLIENTE"}
          open={OpenProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={seteditarProveedor}
          socket={socket}
          ObjectoActivo={ObjectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {usuario.empCategoria === "ISP" && (
        <ModalProveedorISP
          estadoRequest={"CLIENTE"}
          open={OpenProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={seteditarProveedor}
          socket={socket}
          ObjectoActivo={ObjectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {usuario.empCategoria === "VETERINARIA" && (
        <ModalProveedorVet
          estadoRequest={"CLIENTE"}
          open={OpenProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={seteditarProveedor}
          socket={socket}
          ObjectoActivo={ObjectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}
      {usuario.empCategoria === "GASOLINERA" && (
        <ModalProveedor
          estadoRequest={"CLIENTE"}
          open={OpenProveedor}
          setopen={setOpenProveedor}
          editar={editarProveedor}
          seteditar={seteditarProveedor}
          socket={socket}
          ObjectoActivo={ObjectoActivoProveedor}
          changeObjetoActivoState={changeObjetoActivoStateProveedor}
        />
      )}

      {socket.current ? (
        <ModalInventario
          open={openInventario}
          setopen={setopenInventario}
          editar={editarInventario}
          seteditar={seteditarInventario}
          setopenSubCategoria={setopenSubCategoria}
          setopenCategoria={setopenCategoria}
          setOpenProveedor={setOpenProveedorModalI}
          ObjectoActivo={ObjectoActivoInventario}
          changeObjetoActivoState={changeObjetoActivoStateInventario}
          socket={socket}
          seteditarProveedor={seteditarProveedor}
          changeObjetoActivoStateProveedor={changeObjetoActivoStateProveedor}
        />
      ) : null}
      <input
        multiple
        style={{ display: "none" }}
        type="file"
        name="myImage"
        onChange={(e) => {
          setopen(false);
          funcArchivoXmlSri(e);
        }}
        ref={inputXmlSri}
      />

      <DialogOpciones
        open={openDialogOpciones}
        setopen={setopenDialogOpciones}
        botones={[
          // {
          //   tooltip: "Generar ATS",
          //   funcion: () => {
          //     setopen(true);
          //   },
          //   Icon: Add,
          //   color: "primary",
          //   id: 1,
          //   disabled: false,
          // },
          {
            tooltip: "Subir XML RETENCIÓN",
            funcion: () => {
              inputXmlSri.current.click();
            },
            Icon: Add,
            color: "primary",
            id: 1,
            disabled: false,
          },
          {
            tooltip: "Autorizar por lote",
            funcion: async () => {
              try {
                setcargando(true);
                const res = await clienteAxios.post("/ventas");

                mostrarAlerta(res.data.msg, "success");
                funcionDefault();
              } catch (error) {
                setcargando(false);
                mostrarAlerta("Hubo un error", "error");
              }
            },
            Icon: Add,
            color: "primary",
            id: 1,
            disabled: false,
          },
        ]}
        titulo={"Mas Opciones"}
      />
      <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        LabelBuscador="Buscar por todos los campos"
        funcionDefault={funcionDefault}
        ocultarMigasDePan={false}
        botones={[
          {
            tooltip: "Busqueda avanzada",
            texto: "",
            funcion: () => {
              setopenMB(true);
            },
            disabled: false,
            Icon: Search,
            color: "success",
            id: 2,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "medium",
            sx: {
              ml: 1,
            },
          },
          {
            tooltip: "Agregar",
            texto: "Agregar",
            funcion: () => {
              setopen(true);
            },
            disabled: false,
            Icon: Add,
            color: "primary",
            id: 1,
            ocultar: true,
            tipo: "icono",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Agregar",
            texto: "Agregar",
            funcion: () => {
              if (!tienePermiso("agregar")) {
                return alertaPermiso("agregar");
              }
              setopen(true);
            },
            disabled: false,
            Icon: Add,
            color: "primary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Opciones",
            texto: "Opciones",
            funcion: () => {
              setopenDialogOpciones(true);
            },
            disabled: false,
            Icon: Add,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <ModalB
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={`Busqueda avanzada (GUIAS REMISION: ${estadoRequest})`}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        arrayProps={[...columns]}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      />
      {/* <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        setopen={(boolean) => {
          changeObjetoActivoState({
            ...ObjectoActivo,
          });
          return setopen(boolean);
        }}
        open={open}
        openMB={openMB}
        setopenMB={setopenMB}
        LabelBuscador="Buscar por todos los campos"
        funcionDefault={funcionDefault}
        ats={true}
        subirArchivoVentas={true}
        funcArchivoXmlSri={funcArchivoXmlSri}
        // ocultarAgregar={
          // estadoRequest === "ANULADAS" || estadoRequest === "PROCESADAS"
        // }
        ocultarMigasDePan={desdeOtroLugarPersona}
        autorizarPorLote={async () => {
          try {
            setcargando(true);
            const res = await clienteAxios.post("/ventas");

            mostrarAlerta(res.data.msg, "success");
            funcionDefault();
          } catch (error) {
            setcargando(false);
            mostrarAlerta("Hubo un error", "error");
          }
        }}
      />
      <ModalB
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={`Busqueda avanzada (GUIAS REMISION: ${estadoRequest})`}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        arrayProps={columns}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      /> */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems=" stretch"
        width="100%"
      >
        <Box>
          {["PROCESADAS", "SIN AUTORIZAR", "ANULADAS"].map((item) => (
            <Button
              key={item}
              size="small"
              disabled={cargando}
              variant={estadoRequest === item ? "contained" : null}
              onClick={async () => {
                setcargando(true);
                await remplazarRowsState(
                  rowsPerPage,
                  0,
                  "",
                  input.id,
                  orden,
                  JSON.stringify(fullBuscador),
                  rucempresa,
                  item
                );

                setPage(0);
                setestadoRequest(item);
                setcargando(false);
              }}
              disableElevation
              style={{ padding: ".5rem", borderRadius: "15px 15px  0px 0px" }}
              color="primary"
            >
              {item}
            </Button>
          ))}
        </Box>
      </Box>
      <Divider />
      <Tabla
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        search={search}
        input={input}
        orden={orden}
        setinput={setinput}
        setorden={setorden}
        seteditar={seteditar}
        setopen={setopen}
        rows={rows}
        buscando={buscando}
        cargando={cargando}
        setcargando={setcargando}
        fullBuscador={fullBuscador}
        estadoRequest={estadoRequest}
        // STATE
        addRowsState={addRowsState}
        getDataState={getDataState}
        remplazarRowsState={remplazarRowsState}
        obtenerState={obtenerState}
        pagination={pagination}
        columns={columns}
        ObjectoActivo={ObjectoActivo}
        changeObjetoActivoState={changeObjetoActivoState}
        rowsImportState={rowsImportState}
        // export
        arrayExport={arrayExport}
        setarrayExport={setarrayExport}
        campoExport={campoExport}
        socket={socket}
        desdeOtroLugarPersona={desdeOtroLugarPersona}
      />
      {socket.current ? (
        <Modal
          estadoRequest={estadoRequest}
          editar={editar}
          seteditar={seteditar}
          setopen={setopen}
          open={open}
          setopenInventario={setopenInventario}
          setOpenProveedor={setOpenProveedor}
          ObjectoActivo={ObjectoActivo}
          changeObjetoActivoState={changeObjetoActivoState}
          socket={socket}
          seteditarInventario={seteditarInventario}
          changeObjetoActivoStateInventario={changeObjetoActivoStateInventario}
          seteditarProveedor={seteditarProveedor}
          changeObjetoActivoStateProveedor={changeObjetoActivoStateProveedor}
        />
      ) : null}
    </Box>
  );
};

export default memo(GuiaRemision);
